/*
 * Request config for PUTting a file to the presigned URL from GET /s3url.
 *
 * Cache-Control: api/routes/s3url.js signs the URL with a Cache-Control value
 * (image keys are fresh UUIDs, so the file behind a URL never changes and can
 * be cached for a year). It is a signed header - S3 rejects the upload with
 * SignatureDoesNotMatch unless the PUT sends exactly the value that was
 * signed, which is why the API returns it alongside the URL rather than both
 * sides hardcoding it. Omitted if the API didn't send one.
 *
 * Content-Type: without it axios sends application/x-www-form-urlencoded, and
 * S3 stored every photo with that type. It is not part of the signature.
 *
 * The bucket's CORS rules allow any request header, so both pass preflight.
 */
export default function s3PutConfig(s3urlResponse, file) {
    const headers = { "Content-Type": (file && file.type) || "image/jpeg" };
    if (s3urlResponse && s3urlResponse.cacheControl) {
        headers["Cache-Control"] = s3urlResponse.cacheControl;
    }
    return { headers };
}
